export const DELETION_DATE_REGEX = /\[deleted \d{2} \w{3} \d{4}\]/g;
export const DELETION_DATE_ONLY_REGEX = /^\[deleted \d{2} [a-z]{3} \d{4}\]$/;
